export const reduceReadTeamByOrganizationRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingTeam: true },
  };
};

export const reduceReadTeamByOrganizationSuccess = (
  state,
  { payload: { teamByOrganization, organizationId } },
) => {
  const newAllIDs = [];
  const byId = { ...state.base.byId };
  const byBoard = {};

  for (let i = 0, len = teamByOrganization.length; i < len; i += 1) {
    const teamMember = teamByOrganization[i];
    if (teamMember.userId) {
      newAllIDs.push(teamMember.userId);
      byId[teamMember.userId] = { ...teamMember };

      // add this user to byBoard lookup table for each board they are assigned to
      if (teamMember.assignedBoardIDs?.length) {
        for (
          let j = 0, tmLen = teamMember.assignedBoardIDs.length;
          j < tmLen;
          j += 1
        ) {
          const boardId = teamMember.assignedBoardIDs[j];
          byBoard[boardId] = [...(byBoard[boardId] || []), teamMember.userId];
        }
      }
    }
  }

  const uniqByBoard = Object.keys(byBoard).reduce(
    (acc, curr) => ({ ...acc, [curr]: [...new Set([...byBoard[curr]])] }),
    {},
  );

  return {
    ...state,
    base: {
      ...state.base,
      allIDs: [...new Set([...state.base.allIDs, ...newAllIDs])].sort(),
      byId,
    },
    byBoard: uniqByBoard,
    byOrganization: {
      ...state.byOrganization,
      [organizationId]: [...newAllIDs],
    },
    ui: { ...state.ui, isFetchingTeam: false },
  };
};

export const reduceReadTeamByOrganizationFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingTeam: false },
  };
};
